import dynamic from 'next/dynamic'

export const TopBanner = dynamic(() =>
  import('./TopBanner/TopBanner').then(m => m.TopBanner)
)

export const Maavaron = dynamic(() =>
  import('./Interstitial/Maavaron').then(m => m.Maavaron)
)

export const FooterStrip = dynamic(
  () => import('./FooterStrip/Footerstrip').then(m => m.Footerstrip),
  { ssr: false }
)

export const Ozen = dynamic(() => import('./Ozen/Ozen').then(m => m.Ozen))

export const MidBox = dynamic(() =>
  import('./MidBox/MidBox').then(m => m.MidBox)
)

export const Ear = dynamic(() => import('./Ozen/Ear').then(m => m.Ear))

export const Interstitial = dynamic(() =>
  import('./Interstitial/interstitial').then(m => m.InterstitialNew)
)

export const Poster = dynamic(
  () => import('./Poster/Poster').then(m => m.default),
  { ssr: false }
)

export const InArticleBox = dynamic<{ pos: number }>(() =>
  import('./InArticleBox').then(m => m.default)
)
export const TimeLineBox = dynamic<{ pos: number }>(() =>
  import('./TimeLineBox').then(m => m.default)
)
export const UpdateBox = dynamic<{ adPos: number }>(() =>
  import('./UpdateBox').then(m => m.UpdateBox)
)
